// src/components/treinamento/formularios/secoes-csv.js
// =======================================================================
// Colunas calculadas POR SEÇÃO do export CSV — Avaliação de Treinamento
// (ex-Avaliação TSV).
// -----------------------------------------------------------------------
// ⚠️ Nasceu compartilhado com a Auditoria SA (2026-09-22) e voltou a servir
// só a TSV em 2026-09-23 (DEM-00011, T22/ajuste visual): a SA ganhou tela
// própria (AvaliacaoSAHistorico.js, Operacional), com esta mesma conta
// reimplementada lá — os dois lados não importam um do outro porque moram em
// módulos diferentes agora.
//
// ⚠️ DUAS SÉRIES no mesmo CSV (DEM-00011, Fase 3):
//   • Método NOVO (METODO_NOTA presente): a seção é o percentual por CONTAGEM
//     PURA — SIM ÷ (SIM+NÃO) × 100, N/A fora do denominador — a mesma régua do
//     total. Antes somava os PONT_ (peso), um resíduo do método velho que, no
//     método novo, virava um número sem significado (o peso não é mais usado).
//   • Legado (sem METODO_NOTA): mantém a SOMA dos PONT_ (peso) — a série
//     congelada, que não é recalculada.
// A coluna "Método da nota" (METODO_LABEL) diz qual régua vale para a linha
// (tarefa 19): sem ela, um percentual de contagem e uma soma de pontos ficariam
// na mesma coluna sem aviso — 85 de peso pareceria igual a 85% de contagem.
// =======================================================================

// Normaliza a resposta gravada ('Sim'/'Não'/'N/A', com variações de caixa e
// acento) para o método novo. Vazio e N/A caem em 'NA' (fora do denominador).
function normalizarResposta(v) {
  const s = String(v ?? '').trim().toLowerCase();
  if (s === 'sim') return 'SIM';
  if (s === 'nao' || s === 'não') return 'NAO';
  return 'NA';
}

// Percentual de contagem pura de uma seção (método novo). Sem SIM nem NÃO na
// seção (tudo N/A) → '' (vazio no CSV), nunca 0 — 0 seria "reprovou tudo".
function percentualSecao(visita, chaves) {
  let sim = 0;
  let den = 0;
  for (const c of chaves) {
    const r = normalizarResposta(visita[`P_${c}`]);
    if (r === 'SIM') { sim += 1; den += 1; } else if (r === 'NAO') { den += 1; }
  }
  return den > 0 ? Number(((sim / den) * 100).toFixed(2)) : '';
}

// Monta o `calcularExtras` de um formulário a partir das suas seções. Devolve a
// linha acrescida das colunas de seção e do rótulo do método.
function montarCalcularExtras(SECOES) {
  return (visita) => {
    const completa = { ...visita };
    const metodoNovo = !!visita.METODO_NOTA;
    for (const secao of SECOES) {
      completa[secao.key] = metodoNovo
        ? percentualSecao(visita, secao.chaves)
        : secao.chaves.reduce((acc, c) => acc + (Number(visita[`PONT_${c}`]) || 0), 0);
    }
    completa.METODO_LABEL = metodoNovo ? 'Contagem (novo)' : 'Peso (legado)';
    return completa;
  };
}

export { montarCalcularExtras, percentualSecao, normalizarResposta };
